import { doGet, doPost, doPut } from 'hooks/requests';

export const useAutomatiqSyncService = () => {
    const addToken = (data) => doPost(`/automatiq-sync/add-token/`, data);
    const getToken = (data) => doGet(`/automatiq-sync/get-token/?company_id=${data.companyId}`);
    const updateToken = (data) => doPut(`/automatiq-sync/update-token/`, data);

    return {
        addToken,
        getToken,
        updateToken,
    };
};
